module.exports = __webpack_public_path__ + "img/购物车.31f8dc24.png";